import type { Action } from 'redux';

export const CLEAR_QR_CODE_LINK = 'CLEAR_QR_CODE_LINK' as const;

export const clearQrCodeLink = () => ({ type: CLEAR_QR_CODE_LINK });

export type ClearQrCodeLinkResponseAction = Action<typeof CLEAR_QR_CODE_LINK>;
